<div class="documentos-consulta p-3" style="font-family: 'Mulish', sans-serif;">
     <ul class="nav nav-tabs nav-tabs-style mb-3">
            <li class="nav-item">
              <a class="nav-link active" data-toggle="tab" href="#tabAnamnesis">Anamnesis</a>
            </li>
            <li class="nav-item">
              <a class="nav-link" data-toggle="tab" href="#tabDiagnostico">Diagnósticos e indicaciones</a>
            </li>
            <li class="nav-item">
              <a class="nav-link" data-toggle="tab" href="#tabRecetas">Recetas</a>
            </li>
            <li class="nav-item">
              <a class="nav-link" data-toggle="tab" href="#tabCertificados">Certificados</a>
            </li>
            <li class="nav-item">
              <a class="nav-link" data-toggle="tab" href="#tabExamenes">Órdenes de exámenes</a>
            </li>
            <li class="nav-item">
              <a class="nav-link" data-toggle="tab" href="#tabLicencias">Licencias</a>
            </li>
            <li class="nav-item">
              <a class="nav-link" data-toggle="tab" href="#tabDocumentos">Ver y adjuntar documentos</a>
            </li>
            <li class="nav-item">
              <a class="nav-link" data-toggle="tab" href="#tabDerivaciones">Derivaciones</a>
            </li>
          </ul>

          <div class="tab-content">
            <div class="tab-pane fade show active" id="tabAnamnesis">
              <label class="font-weight-bold"><i class="fas fa-pen"></i> Anamnesis</label>
              <textarea class="form-control" placeholder="Insertar información..." rows="4"></textarea>
              <button class="btn btn-primary rounded-pill mt-3 px-4">Guardar cambios</button>
            </div>
          </div>
        <hr class="my-4">

   
    </div>